"use client";

import { useRouter } from "next/navigation";
import { cn } from "@/lib/utils";

/**
 * Back control for the legal / info pages. Returns the user to wherever they came
 * from (Profile when opened from Profile — the previous hardcoded "/login" link
 * was the bug), falling back to /preferences when there is no in-app history
 * (e.g. a cold deep-link into /privacy).
 */
export default function BackButton({
  label = "← Back",
  fallback = "/preferences",
  className,
}: {
  label?: string;
  fallback?: string;
  className?: string;
}) {
  const router = useRouter();
  const onClick = () => {
    if (typeof window !== "undefined" && window.history.length > 1) router.back();
    else router.push(fallback);
  };
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "inline-flex items-center gap-1 text-[#25442a] text-sm font-medium hover:underline",
        className,
      )}
    >
      {label}
    </button>
  );
}
